export const MIN_RATIO = 10;
